import React from 'react';

/**
 * Shown in the system browser after the user completes Google sign-in
 * as part of the Capacitor WebView deep-link flow.
 * 
 * The Allure app is polling /api/auth/poll-app-token in the background.
 * Tapping "Open Allure App" fires the allurexp:// custom URI scheme,
 * which brings the app to the foreground via the existing intent filter.
 */
export default function AppLoginCompletePage() {
  const [triedOpen, setTriedOpen] = React.useState(false);

  // Automatically attempt to bring the app to foreground after a short delay
  React.useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = 'allurexp://auth';
      setTriedOpen(true);
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  const openApp = () => {
    window.location.href = 'allurexp://auth';
    setTriedOpen(true);
  };

  return (
    <div
      data-testid="app-login-complete-page"
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0a0a0a',
        padding: 32,
      }}
    >
      {/* Checkmark */}
      <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 28 }}>
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="18" fill="#e53e3e" opacity="0.15" />
          <path d="M10 18l6 6 10-12" stroke="#e53e3e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 700, marginBottom: 10, textAlign: 'center' }}>
        You&rsquo;re signed in!
      </h1>
      <p style={{ color: '#888', fontSize: 15, textAlign: 'center', marginBottom: 36, lineHeight: 1.6, maxWidth: 280 }}>
        Return to the Allure app to continue. It should open automatically.
      </p>

      <button
        data-testid="app-login-return-button"
        onClick={openApp}
        style={{
          background: '#e53e3e',
          color: '#fff',
          border: 'none',
          borderRadius: 14,
          padding: '15px 36px',
          fontSize: 16,
          fontWeight: 700,
          cursor: 'pointer',
          width: '100%',
          maxWidth: 320,
          letterSpacing: 0.3,
        }}
      >
        Open Allure App
      </button>

      {triedOpen && (
        <p data-testid="app-login-fallback-hint" style={{ color: '#555', fontSize: 13, marginTop: 20, textAlign: 'center' }}>
          Already back in the app? You should be logged in now.
        </p>
      )}
    </div>
  );
}
